import styled, { css } from 'react-emotion'
import { link } from './platformLinkStyles'

const Link = styled.div`
  cursor: pointer;
  transition: transform 0.15s;

  ${link};

  ${({ showInput }) =>
    showInput &&
    css`
      transform: rotateX(180deg);
      opacity: 0;
      position: absolute;
      z-index: 0;
    `};
`

export default Link



// WEBPACK FOOTER //
// ./src/routes/home/components/Link.js